import React, { useEffect, useState } from "react";
import { NavLink, Navigate, Outlet, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faIdCard,
  faBars,
  faGear,
  faClipboardCheck,
  faRightFromBracket,
  faUser,
  faUserGroup,
  faMoneyCheckDollar,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../context/AuthContext";
import CompleteRegistration from "./completeRegistration";
import "../Auth/auth.css";
import "./account.css";
import { fullName } from "../../utils/fullName";

const MENU = [
  { to: "/profile", label: "Իմ էջը", icon: faUser, end: true },
  { to: "/profile/settings", label: "Կարգավորումներ", icon: faGear },
  { to: "/profile/cards", label: "Քարտեր", icon: faIdCard },
  { to: "/profile/team", label: "Իմ թիմը", icon: faUserGroup },
  { to: "/profile/payments", label: "Վճարումներ", icon: faMoneyCheckDollar },
];

const TRAINER_ITEM = { to: "/profile/requests", label: "Քարտի հայտեր", icon: faClipboardCheck };

const AccountLayout = () => {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (!menuOpen) return undefined;
    const onKey = (e) => e.key === "Escape" && setMenuOpen(false);
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [menuOpen]);

  if (loading) return <div className="account-page" />;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.profile_complete) return <CompleteRegistration />;

  const handleLogout = async () => {
    setMenuOpen(false);
    await logout();
    navigate("/");
  };

  return (
    <div className="account-page">
      <button
        type="button"
        className="account-burger"
        aria-label="Մենյու"
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen(true)}
      >
        <FontAwesomeIcon icon={faBars} />
        <span>Անձնական էջ</span>
      </button>
      <div
        className={`account-overlay${menuOpen ? " open" : ""}`}
        onClick={() => setMenuOpen(false)}
      />
      <aside className={`account-sidebar${menuOpen ? " open" : ""}`}>
        <button
          type="button"
          className="account-close"
          aria-label="Փակել"
          onClick={() => setMenuOpen(false)}
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
        <div className="account-user">
          <img src={user.image_url} alt="avatar" />
          <span>
            {fullName(user)}
          </span>
        </div>
        <nav className="account-menu">
          {(user.is_trainer ? [...MENU, TRAINER_ITEM] : MENU).map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) => `account-menu-item${isActive ? " active" : ""}`}
            >
              <FontAwesomeIcon icon={item.icon} />
              <span>{item.label}</span>
            </NavLink>
          ))}
          <button type="button" className="account-menu-item logout" onClick={handleLogout}>
            <FontAwesomeIcon icon={faRightFromBracket} />
            <span>Ելք</span>
          </button>
        </nav>
      </aside>
      <main className="account-content">
        <Outlet />
      </main>
    </div>
  );
};

export default AccountLayout;
